export const FIXED_WIDTH_CLASS = '!gl-w-31';
export const DEFAULT_OFFSET = 8;
export const ARROW_X_MINIMUM = 24;
